module.exports = __webpack_public_path__ + "assets/skill-reading.48aa2b23.svg";